import { render, staticRenderFns } from "./relativa-pronomen-nominativ.vue?vue&type=template&id=0a9b3a12&scoped=true"
import script from "./relativa-pronomen-nominativ.vue?vue&type=script&lang=js"
export * from "./relativa-pronomen-nominativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b3a12",
  null
  
)

export default component.exports